import React from "react";

class db extends React.Component {

    // getFacilities( callBack,  params)
    // get list of clients baste on params
    // example:
    //    getFacilities( callBack )  # get all client
    //    getFacilities( callBack, "id=1" )  # get the client where id eauals 1
    static getFacilities( search_column, orgId, facility_id, company_id, securityObject, callBack) {
        // get clients
        var http = securityObject.httpServer + "api/get/facility?";
        if(search_column){
            http += `search_column=${search_column}&`;
        }
        if(orgId){
            http += `organization_id=${orgId}&`;
        }
        //if (facility_name && facility_name!=="") {
        //    http += `facility_name=${facility_name}&`;
        //}
        if (facility_id && facility_id!=="") {
            http += `facility_id=${facility_id}&`;
        }   
        if (company_id && company_id!=="") {
            http += `company_id=${company_id}&`;
        }                  
        fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callBack){
                callBack(json.resultObject);
            }
        });
    }
    static getFacility( facilityId, securityObject, callBack) {
        // get clients
        var http = securityObject.httpServer + "api/get/facility?";
        http += `id=${facilityId}&`;
        fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callBack){
                callBack(json.resultObject[0]);
            }
        });
    }    
    static getHub( hubId, securityObject, callBack,  params) {
        // get clients
        try{
            var http = securityObject.httpServer + "api/get/hub";
            http += `?id=${hubId}`;
            fetch(http, this.getStandardJsonRequestOptions(securityObject))
            .then((res) => res.json())
            .then((json) => {
                if(callBack){
                    callBack(json.resultObject);
                }
            });
        } catch(e){
            window.alert(e);
        }
    }
    static getBeacons( major, minor, barcode, hostnames, securityObject, callBack,  params) {
        // get clients
        var http = securityObject.httpServer + "api/get/beacon?";
        if (major!=="") {
            http += `major=${major}&`;
        }
        if (minor!=="") {
            http += `minor=${minor}&`;
        }
        if (barcode!=="") {
            http += `barcode=${barcode}&`;
        }
        if (hostnames!=="") {
            http += `hostnames=${hostnames}&`;
        }        
        fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callBack){
                callBack(json.resultObject);
            }
        });
    } 
    static getSubmersions( hostname, limit, securityObject, callBack,  params) {
        // get clients
        var http = securityObject.httpServer + "api/get/submersion?";
        if (hostname!=="") {
            http += `hostname=${hostname}&`;
        }
        if (limit!=="") {
            http += `limit=${limit}&`;
        }
        fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callBack){
                callBack(json.resultObject);
            }
        });
    } 
    static getWarnings( hostname, warning_type, send_warnings_to_slack, securityObject, callBack,  params) {
        // get clients
        var http = securityObject.httpServer + "api/get/warning?";
        if (hostname!=="") {
            http += `hostname=${hostname}&`;
        }
        if (warning_type!=="") {
            http += `warning_type=${warning_type}&`;
        }
        if(send_warnings_to_slack){
            http += `send_warnings_to_slack=Y&`;
        }
        fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callBack){
                callBack(json.resultObject);
            }
        });
    } 
    static getBeaconHistory( leftMac, rightMac, securityObject, callBack) {
        // get clients
        var http = securityObject.httpServer + `api/get/beaconHistory?leftMac=${leftMac}&rightMac=${rightMac}`;
        fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callBack){
                callBack(json.resultObject);
            }
        });
    } 
    static getHubTestEvent( hubTestId, securityObject, callBack) {
        // get clients
        var http = securityObject.httpServer + `api/get/hubTestEvents?hubTestId=${hubTestId}`;
        fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callBack){
                callBack(json.resultObject);
            }
        });
    }     
    static getHubUpdateList( securityObject, callBack) {
        // get clients
        var http = securityObject.httpServer + `api/get/hubupdate`;
        fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callBack){
                callBack(json.resultObject);
            }
        });
    }    
    static getHubspotDeal( dealId, securityObject, callBack) {
        var http = securityObject.httpServer + `api/get/hubSpotDeal?hubspotObjectId=${dealId}`;
        fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callBack){
                callBack(json.resultObject);
            }
        });
    }  
    static getHubspotContacts( companyId, securityObject, callBack) {
        var http = securityObject.httpServer + `api/get/hubSpotContact?hubspot_company_object_id=${companyId}`;
        fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callBack){
                callBack(json.resultObject);
            }
        });
    }                    
    static getHubspotContactsWithParent( companyId, securityObject, callBack) {
        var http = securityObject.httpServer + `api/get/hubSpotContactWithParent?hubspot_company_child_object_id=${companyId}`;
        fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callBack){
                callBack(json.resultObject);
            }
        });
    }                    
    static getHubs( search_column, display_name, host_name, facility_id, securityObject, callBack,  params) {
        var http = securityObject.httpServer + "api/get/hubList?";
        if(search_column!==""){
            http+=`search_column=${search_column}&`;
        }        
        if(display_name!==""){
            http+=`display_name=${display_name}&`;
        }
        if(host_name!==""){
            http+=`host_name=${host_name}&`;
        }
        if(facility_id!==""){
            http+=`facility_id=${facility_id}&`;
        }        
        fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callBack){
                callBack(json.resultObject);
            }
        });
    } 
    // getStandardJsonRequestOptions
    static getStandardJsonRequestOptions(securityObject){
        return {
            method: "GET",
            headers: { 
                'Content-Type': 'application/json',
                'Session-Id': securityObject.userSessionId
            },
            credentials: 'same-origin'
        };
    }
    // postStandardJsonRequestOptions
    static postStandardJsonRequestOptions( securityObject, data){
        return {
            method: "POST",
            headers: { 
                'Content-Type': 'application/json',
                'Session-Id':securityObject.userSessionId
            },
            body: JSON.stringify(this.getSubmitData(data)),
            credentials: 'same-origin'
        };
    }    
    // save date
    static saveData( securityObject, data, postMethod, onSuccess, onFail){
        fetch(securityObject.httpServer+postMethod, this.postStandardJsonRequestOptions( securityObject, data))
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                //alert(data.resultMessage);
                // check for error response
                if (!response.ok || data.resultCode===0) {
                    // get error message from body or default to response status
                    //mainThis.setState({ errorMessage: data });
                    window.alert(data.resultMessage);
                    return Promise.reject(data);
                }

                // hide popup
                if(onSuccess){
                    onSuccess(data);
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
                if(onFail){
                    onFail(error);
                }
            });
    }
    // getSubmitData
    static getSubmitData(data){
        return { 
            data:data
        };
    }        

  // getSystemSettings( callback )
  static getSystemSettings( securityObject, callback ) {
    // get settings
    let http = securityObject.httpServer + "api/get/systemSettings";
    fetch(http, this.getStandardJsonRequestOptions(securityObject))
      .then((res) => res.json())
      .then((json) => {
        if(callback){
            callback(json.resultObject);
        }
      });
  }
  // getServerVersion( callback )
  static getServerVersion( securityObject, callback ) {
    // get settings
    let http = securityObject.httpServer + "api/get/version";
    fetch(http, this.getStandardJsonRequestOptions(securityObject))
      .then((res) => res.json())
      .then((json) => {
        if(callback){
            callback(json.version);
        }
      });
  }


  // getProductList( callback )
  static getProductList( securityObject, callback ) {
    // get settings
    let http = securityObject.httpServer + "api/get/inventoryProducts";
    fetch(http, this.getStandardJsonRequestOptions(securityObject))
      .then((res) => res.json())
      .then((json) => {
        if(callback){
            callback(json.resultObject);
        }
      });
  }

  static getMaxHub(filter, securityObject, callback){
    // get settings
    let http = securityObject.httpServer + `api/get/maxHub?hostname_prefix=${filter}`;
    fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
        if(callback){
            callback(json.resultObject);
        }
        });
  }
  //getProductBom
  static getProductBom(productName, securityObject, callback){
    // get settings
    let http = securityObject.httpServer + `api/get/productBOM?product_variant_name=${productName}`;
    fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
        if(callback){
            callback(json.resultObject);
        }
        });
  }
  static getThirdPartyWebHookData( 
    third_party_client
    ,facility_id
    ,post_type
    ,facility_name
    ,assigned
    ,securityObject
    ,callback
  ){
    let http = securityObject.httpServer + `api/get/ThirdPartyWebHooks?third_party_client=${third_party_client}&post_type=${post_type}&facility_name=${facility_name}&assigned=${assigned}&facility_id=${facility_id}`;
    fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callback){
                callback(json.resultObject);
            }
        });
  }
  static getFactoryHosts( securityObject, callback){
    let http = securityObject.httpServer + `api/get/factoryDevices`;
    fetch(http, this.getStandardJsonRequestOptions(securityObject))
        .then((res) => res.json())
        .then((json) => {
            if(callback){
                callback(json);
            }
        });
  }
  static getSearchPopupData( http, securityObject, callBack) {
    console.log(http);
    fetch(http, this.getStandardJsonRequestOptions(securityObject))
    .then((res) => res.json())
    .then((json) => {
        if(callBack){
            callBack(json.resultObject);
        }
    });
   }
   static getDeviceLookup(securityObject,val, callBack){
        let qry=securityObject.httpServer + `api/get/deviceLookup?device_identifier=${val}`;
        this.getSearchPopupData( 
                qry
                ,securityObject
                ,(qryResult) => { 
                    callBack(qryResult);
                }
   )
   }
   static getOrderHeader(securityObject,id, callBack){
    let qry=securityObject.httpServer + `api/get/orderHeader?id=${id}`;
    this.getSearchPopupData( 
            qry
            ,securityObject
            ,(qryResult) => { 
                callBack(qryResult);
            }
)
}

}
export default db;